import { UserModel } from '@/shared/models/user.model';
import { UserUIModel } from '@/shared/ui-models/user.ui-model';

function mapToUI(userData: UserModel): UserUIModel {
  return {
    id: userData.id,
    name: userData.name,
    email: userData.email,
    gender: userData.gender,
    phone: userData.phone,
    role: userData.role,
    organization: userData.organization,
    socialLink: userData.socialLink,
    createdAt: userData.createdAt,
    isPhoneSuspended: userData.isPhoneSuspended,
    isPhoneVerified: userData.isPhoneVerified,
    isDeactivated: userData.isDeactivated,
    suspendedUntil: userData.suspendedUntil,
    emailLoginRateLimit: userData.emailLoginRateLimit,
    image: userData.image,
    key: userData.key
  };
}

function mapToModel(userData: Partial<UserUIModel>): UserModel {
  return {
    userId: userData.id || '',
    name: userData.name,
    email: userData.email,
    gender: userData.gender,
    phone: userData.phone,
    image: userData.image,
    key: userData.key,
    role: userData.role,
    organization: userData.organization,
    socialLink: userData.socialLink,
    createdAt: userData.createdAt,
    isDeactivated: userData.isDeactivated
  };
}

function mapToUIList(usersList: UserModel[]): UserUIModel[] {
  if (!usersList || !Array.isArray(usersList)) {
    return [];
  }

  return usersList.map(mapToUI);
}

export default {
  mapToUI,
  mapToModel,
  mapToUIList
};
